import { Dispatch } from 'redux'
import * as Api from 'libs/api'

export function sendPutPrescriptionRead(idToken: string | undefined, shopId: string, prescriptionId: string) {
  return async (dispatch: Dispatch) => {
    // Send GET /mc/shops/{shopId}/prescriptions/{prescriptionId}/read
    await Api.callApi(
      Api.HttpMethod.put,
      `shops/${shopId}/prescriptions/${prescriptionId}/read`,
      idToken,
      null,
      dispatch,
    )
  }
}
